import { TypeDocs } from "../../../../../src/docs-components/TypeDocs";
import { ChonkyIconFA } from 'chonky-icon-fontawesome';
import * as React from 'react';
export default {
  TypeDocs,
  ChonkyIconFA,
  React
};